//@flow

// Vendors
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import {
  openHoustonErrorModal,
  toggleModal,
} from '../../../../reducers/modal/modalActions';
import {
  deletePaymentAccount,
  getPaymentAccounts,
} from '../../../../reducers/payment/paymentActions';
import {
  AUTHOR_TYPES,
  pushMessageBanner,
} from '../../../../reducers/messageBanner/messageBannerActions';

// Helpers
import { getCurrentFormattedTime } from '../../../../lib/helpers';

// Selectors
import { selectModalData } from '../../../../reducers/modal/modalSelectors';

// Components
import { Trans } from '../..';
import { Modal } from '../../modals';
import { Button, ButtonDanger } from 'texkit/dist/components/Buttons';
import { PaymentCard } from '../../../Payment';

// Styles
import './delete-payment-account-modal.scss';

const DeletePaymentAccountModal = () => {
  const dispatch = useDispatch();
  const { paymentAccount } = useSelector(selectModalData);
  const [removing, setRemoving] = useState(false);

  const onConfirm = async () => {
    setRemoving(true);

    try {
      await dispatch(
        deletePaymentAccount({
          paymentAccountId: paymentAccount.paymentAccountId,
        })
      );
      dispatch(
        pushMessageBanner([
          {
            messageId: Date.now().toString(),
            textEnglish: '{"type": "Alerts", "id": "SuccessCardRemoved"}',
            textSpanish: '{"type": "Alerts", "id": "SuccessCardRemoved"}',
            startTime: getCurrentFormattedTime(),
            endTime: getCurrentFormattedTime(60),
            priority: '4',
            status: 'R',
            author: AUTHOR_TYPES.ACTION_RESULT,
            valid: true,
            dismissable: true,
            expiresIn: 60000,
          },
        ])
      );
      dispatch(toggleModal('DeletePaymentAccountModal'));
      dispatch(getPaymentAccounts());
    } catch (error) {
      const options = {
        navigateOnClose: false,
      };
      dispatch(openHoustonErrorModal(options));
    } finally {
      setRemoving(false);
    }
  };

  return (
    <Modal
      name="DeletePaymentAccountModal"
      className="delete-payment-account-modal"
    >
      {paymentAccount && (
        <>
          <h2 className="h1 modal-title delete-payment-account-modal-header">
            <Trans
              file="Payment"
              id="RemovePaymentMethodConfirmQuestion"
              fallback="Do you want to remove this card?"
            />
          </h2>
          <div className="modal-content delete-payment-account-modal-content">
            <PaymentCard paymentAccount={paymentAccount} />
          </div>
          <div className="modal-footer delete-payment-account-modal-footer">
            <Button
              onClick={() => dispatch(toggleModal('DeletePaymentAccountModal'))}
            >
              <Trans file="Labels" id="Cancel" fallback="Cancel" />
            </Button>
            <ButtonDanger
              isLoading={removing}
              loadingContent={
                <Trans file="Labels" id="Removing" fallback="Removing" />
              }
              className="delete-payment-account-modal-button"
              onClick={onConfirm}
            >
              <Trans
                file="Payment"
                id="RemovePaymentMethodConfirmButton"
                fallback="Yes, Remove Card"
              />
            </ButtonDanger>
          </div>
        </>
      )}
    </Modal>
  );
};

export default DeletePaymentAccountModal;
